import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";

import { ShiftReportProductionSummary } from "@/pages/shift-report/models/ShiftReportResponse";
import { backgroundColor } from "@/utils/theme";
import { RowClassParams, RowStyle } from "ag-grid-community";
import { useTableData } from "./useTableData";

export const TableProductionSummary = ({
	productionSummary,
	hoveredSectionId,
	onSectionHover,
	hiddenColumns,
}: {
	productionSummary: ShiftReportProductionSummary[];
	hoveredSectionId: number | null;
	onSectionHover?: (heatId: number | null) => void;
	hiddenColumns?: string[];
}) => {
	const { columnDefs } = useTableData(hiddenColumns);
	const { defaultColDef } = useGridDefinitions({});

	const getRowStyle = (
		params: RowClassParams<ShiftReportProductionSummary, any>,
	): RowStyle | undefined => {
		const productionSummary = params.data;
		if (!productionSummary) return undefined;

		if (productionSummary.SectionId == hoveredSectionId)
			return { backgroundColor: backgroundColor };

		return undefined;
	};

	return (
		<>
			<Paper
				elevation={2}
				sx={{
					height: "100%",
					width: "100%",
					"& .ag-cell": {
						fontSize: 11,
					},
					"& .heat-cell": {
						paddingLeft: "2.5rem !important",
						display: "flex",
						alignItems: "center",
					},
				}}
			>
				<AgGridReact<ShiftReportProductionSummary>
					rowData={productionSummary || []}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowHeight={30}
					headerHeight={34}
					animateRows
					getRowId={(params) => String(params.data.SectionId)}
					getRowStyle={getRowStyle}
					loadingOverlayComponent={CenteredLazyLoading}
					onCellMouseOver={(e) => onSectionHover?.(e.data?.SectionId ?? null)}
					onCellMouseOut={() => onSectionHover?.(null)}
				/>
			</Paper>
		</>
	);
};
